<router-outlet />

<cve-ui-loader />
